<template>
  <div class="checkingTable">
    <ul>
      <li class="checkingTable_item">
        <div class="tableTitle">
          <span class="tableTitle_left">考勤规则配置</span>
          <span v-if="permisShow('考勤組配置')" class="tableTitle_right" @click="addRuleConfiguration" style="cursor:pointer;">新增考勤组</span>
        </div>
        <div class="table" v-if="permisShow('考勤配置查看')">
          <el-table border style="width: 100%" :header-cell-style="setHeaderStyle" :data="ruleConfigurationList">
            <el-table-column prop="name" label="名称" width="180"></el-table-column>
            <el-table-column prop="employeeNumber" label="考勤人数" width="180"></el-table-column>
            <el-table-column prop="attendanceTime" label="考勤时间"></el-table-column>
            <el-table-column prop="attendanceSpace" label="考勤地点"></el-table-column>
            <el-table-column prop="status" v-if="permisShow('考勤組配置')" label="是否启用" width="180">
              <template slot-scope="scope">
                <el-switch style="display: block" active-color="#5e75e6" inactive-color="#e6e6e6" active-value="ENABLE" inactive-value="DISABLE" v-model="scope.row.status" @change="switchRuleChange(scope.row)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="address" v-if="permisShow('考勤組配置')" label="操作" width="180">
              <template slot-scope="scope">
                <span style="cursor: pointer;color: #5E75E6;padding-right: 6px;" @click="editorRuleConfiguration(scope.row)">编辑</span>
                <span style="cursor: pointer;color: #FF0000" @click="deleteRuleConfiguration(scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </li>
      <li class="checkingTable_item">
        <div class="tableTitle">
          <span class="tableTitle_left">请假类型</span>
          <span class="tableTitle_right" v-if="permisShow('请假配置')" style="cursor:pointer;" @click="openType">新增</span>
        </div>
        <div class="table">
          <el-table border v-if="permisShow('考勤配置查看')" style="width: 100%" :header-cell-style="setHeaderStyle" :data="typeList">
            <el-table-column prop="name" label="类型"></el-table-column>
            <el-table-column prop="whetherMoney" label="是否带薪"></el-table-column>
            <el-table-column prop="checkName" label="审批流"></el-table-column>
            <el-table-column prop="address" v-if="permisShow('请假配置')" label="操作">
              <template slot-scope="scope">
                <span style="cursor: pointer;color: #5E75E6;padding-right: 6px;" @click="editType(scope.row)">编辑</span>
                <span style="cursor: pointer;color: #FF0000" @click="deleteType(scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </li>
<!--      <li class="checkingTable_item">-->
<!--        <div class="tableTitle">-->
<!--          <span class="tableTitle_left">审批设置</span>-->
<!--          <span class="tableTitle_right" v-if="permisShow('审批流配置')" @click="goCheckingset" style="cursor:pointer;">新增</span>-->
<!--        </div>-->
<!--        <div class="table">-->
<!--          <el-table border v-if="permisShow('考勤配置查看')" style="width: 100%" :header-cell-style="setHeaderStyle" :data="setList">-->
<!--            <el-table-column prop="name" label="名称" width="180"></el-table-column>-->
<!--            <el-table-column prop="type" label="类型" width="180"></el-table-column>-->
<!--            <el-table-column prop="status" v-if="permisShow('审批流配置')" label="是否启用" width="180">-->
<!--              <template slot-scope="scope">-->
<!--                <el-switch style="display: block" active-color="#5e75e6" inactive-color="#e6e6e6" active-value="YES" inactive-value="NO" v-model="scope.row.whetherOpen" @change="switchSetChange(scope.row)"></el-switch>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="checkEmployeeIds" label="审批人"></el-table-column>-->
<!--            <el-table-column prop="address" v-if="permisShow('审批流配置')" label="操作" width="180">-->
<!--              <template slot-scope="scope">-->
<!--                <span style="cursor: pointer;color: #5E75E6;padding-right: 6px;" @click="editSet(scope.row)">编辑</span>-->
<!--                <span style="cursor: pointer;color: #FF0000" @click="deleteSet(scope.row)" v-if="scope.row.whetherDelete==true">删除</span>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--          </el-table>-->
<!--        </div>-->
<!--      </li>-->
    </ul>
    <div class="dialogStyle">
      <el-dialog width="510px" :title="typeTitle" :visible.sync="dialogShow">
        <ul>
          <li class="wrap">
            <span class="name">
              <span class="xing">*</span>名称:
            </span>
            <el-input v-model="form.name"></el-input>
            <el-checkbox v-model="form.whetherMoney">是否带薪</el-checkbox>
          </li>
          <li class="wrap">
            <span class="name">
              <span class="xing">*</span>审批流:
            </span>
            <el-select v-model="form.checkId" placeholder="请选择">
              <el-option v-for="(item,index) in checkList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </li>
        </ul>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogShow = false">取 消</el-button>
          <el-button v-points type="primary" @click="addType">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  deleteRule,
  queryRuleList,
  queryType,
  querySet,
  updateRuleStatus,
  updateSet,
  updateType,
  addType,
  queryCheck,
  queryNoApprovalType
} from "@/api/checkingIn";
export default {
  data() {
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    return {
      permisList,
      typeTitle: "",
      form: {
        name: "",
        whetherMoney: false,
        checkId: ""
      },
      dialogShow: false, //请假类型
      Rule: "", //规则配置是否启用
      ruleConfigurationList: [], //考勤配置列表
      typeList: [], //请假类型列表
      setList: [], //审批设置列表
      checkList: [] //审批流列表
    };
  },
  mounted() {
    this.getRuleConfiguration(); //查询考勤组
    this.getType(); //查询请假类型
    this.getSet(); //查询审批设置
    this.getQueryCheck(); //查询审批流
  },
  watch: {
    setList() {
      this.getQueryCheck(); //查询审批流
    }
  },
  methods: {
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    //考勤规则配置是否启用
    switchRuleChange(val) {
      let params = {
        status: val.status,
        id: val.id
      };
      this.$post(updateRuleStatus, params).then(res => {
        if (res.success) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getRuleConfiguration();
        }
      });
    },
    //考勤审批设置是否启用
    switchSetChange(val) {
      let params = {
        whetherOpen: val.whetherOpen,
        id: val.id
      };
      this.$post(updateSet, params).then(res => {
        if (res.success) {
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getSet();
        }
      });
    },
    //删除请假类型
    deleteType(val) {
      this.$confirm("删除后将不可恢复，请谨慎操作！", "确定要删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        distinguishCancelAndClose: true
      }).then(() => {
        let params = {
          whetherOpen: "DELETE",
          id: val.id
        };
        this.$post(updateType, params).then(res => {
          if (res.success) {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.getType();
          }
        });
      });
    },
    //编辑审批设置
    editSet(val) {
      sessionStorage.setItem("setId", val.id);
      this.$router.push("/checkingSet");
    },
    //删除审批设置
    deleteSet(val) {
      this.$confirm("删除后将不可恢复，请谨慎操作！", "确定要删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        distinguishCancelAndClose: true
      }).then(() => {
        let params = {
          whetherOpen: "DELETE",
          id: val.id
        };
        this.$post(updateSet, params).then(res => {
          if (res.success) {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.getSet();
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      });
    },
    //跳转至新增审批设置
    goCheckingset() {
      sessionStorage.setItem("setId", "");
      this.$router.push("/checkingSet");
    },
    //表单头部颜色
    setHeaderStyle() {
      return "background-color: #F2F4FF";
    },
    //查询考勤组
    getRuleConfiguration() {
      this.$post(queryRuleList).then(res => {
        if (res.success) {
          this.ruleConfigurationList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //打开请假类型
    openType() {
      this.dialogShow = true;
      this.typeTitle = "请假类型";
      this.form.name = "";
      this.form.whetherMoney = false;
      this.form.checkId = "";
    },
    //编辑请假类型
    editType(val) {
      console.log(val);
      this.dialogShow = true;
      this.typeTitle = "编辑请假类型";
      this.form.name = val.name;
      if (val.whetherMoney == "是") {
        this.form.whetherMoney = true;
      } else {
        this.form.whetherMoney = false;
      }

      this.form.checkId = val.checkId;
      this.form.id = val.id;
    },
    //新增请假类型
    addType() {
      if(!this.form.name){
        this.$message.error("名称不能为空");
        return;
      }
      if(!this.form.checkId){
        this.$message.error("请选择审批流");
        return;
      }
      let params = Object.assign({}, this.form);
      let typeType = "";
      if (this.typeTitle == "请假类型") {
        typeType = addType;
      } else if (this.typeTitle == "编辑请假类型") {
        typeType = updateType;
      }
      this.$post(typeType, params).then(res => {
        if (res.success) {
          this.$message({
            type: "success",
            message: res.msg
          });

          this.dialogShow = false;
          this.getType(); //查询请假类型
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //查询请假类型
    getType() {
      this.$post(queryType).then(res => {
        if (res.success) {
          res.data.map((item, index) => {
            if (item.whetherMoney == true) {
              item.whetherMoney = "是";
            } else {
              item.whetherMoney = "否";
            }
          });
          this.typeList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //请假类型查询审批流
    getQueryCheck() {
      this.$post(queryNoApprovalType).then(res => {
        if (res.success) {
          this.checkList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //查询审批设置
    getSet() {
      this.$post(querySet).then(res => {
        if (res.success) {
          this.setList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //新增考勤组
    addRuleConfiguration() {
      sessionStorage.setItem("ruleConfiguration", "新增");
      this.$router.push("/ruleConfiguration");
    },
    //编辑考勤组
    editorRuleConfiguration(row) {
      sessionStorage.setItem("ruleConfigurationId", row.id);
      sessionStorage.setItem("ruleConfiguration", "编辑");
      this.$router.push("/ruleConfiguration");
    },
    //删除考勤组
    deleteRuleConfiguration(row) {
      this.$confirm("删除后将不可恢复，请谨慎操作！", "确定要删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        distinguishCancelAndClose: true
      }).then(() => {
        //确定
        let params = {
          id: row.id
        };
        this.$post(deleteRule, params).then(res => {
          if (res.success === true) {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.getRuleConfiguration(); //查询考勤组
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      });
    }
  }
};
</script>
<style lang="less">
.checkingTable {
  .el-switch {
    margin-top: 5px;
    .el-switch__core:after {
      background: #ffffff;
    }
  }
  // 新增部门弹出框样式
  .el-dialog {
    .el-dialog__body {
      padding: 30px;
    }
    .el-dialog__title {
      font-size: 20px;
      color: #5e75e6;
    }
    .el-dialog__headerbtn .el-dialog__close {
      font-size: 25px;
    }
  }
  .el-input {
    height: 30px;
    width: 170px;
    margin-right: 60px;
    .el-input__inner {
      height: 30px;
    }
  }
}
</style>
<style lang='less' scoped>
.checkingTable {
  background: #fff;
  margin-left: 2px;
  padding: 30px;
  .dialogStyle {
    .wrap {
      height: 30px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      .name {
        display: block;
        width: 62px;
        text-align: right;
        margin-right: 4px;
        font-size: 14px;
        .xing {
          color: red;
        }
      }
    }
  }
  .checkingTable_item {
    margin-bottom: 16px;
    .tableTitle {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      .tableTitle_right {
        display: inline-block;
        padding: 8px 16px;
        background: #5e75e6;
        color: #fff;
        border-radius: 3px;
      }
    }
  }
}
</style>